import React from "react"
import type { PosicaoClientesModel } from "../models/posicaoClientesModel"
import { PosicaoClientesInicial } from "../models/posicaoClientesModel"
import type { PosicaoClientesAction } from "./posicaoClientesActions"

interface PosicaoClientesContextValue {
    dados: PosicaoClientesModel
    dispatch: React.Dispatch<PosicaoClientesAction>
    pesquisar: () => Promise<void>
    erroCarregamento: string | null
}

export const PosicaoClientesContext = React.createContext<PosicaoClientesContextValue>({
    dados: PosicaoClientesInicial,
    dispatch: () => undefined,
    pesquisar: async () => undefined,
    erroCarregamento: null,
})
